import { useState } from 'react'
import { useRouter } from 'next/router'
import { STATIC_IMAGE_BASE } from '@mc/constants'
import {
  Dropdown,
  DropdownToggle,
  Button,
  DropdownContentControlled,
  DropdownItem,
  IconChevronDownDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import Image from 'components/LegacyImage'
import Link from 'components/Link'
import { trackSolutionsClick, trackSolutionsItemClick } from './utils'

const Item = ({
  imgSrc,
  title,
  desc,
  path,
}: {
  imgSrc: string
  title: string
  desc: string
  path: string
}) => {
  const { pathname, query } = useRouter()

  return (
    <Link
      href={path}
      onClick={() =>
        trackSolutionsItemClick({
          action: `Solutions Dropdown: ${title}`,
          pathname,
          query,
        })
      }
    >
      <div className='d-flex mc-p-4'>
        <Image
          className='mc-corners--sm'
          src={`${STATIC_IMAGE_BASE}/${imgSrc}`}
          width={126}
          height={80}
          alt=''
        />
        <div className='mc-mx-4'>
          <h2 className='mc-text-h6 mc-mb-2'>{title}</h2>
          <p className='mc-text-small mc-text-color--tint'>{desc}</p>
        </div>
      </div>
    </Link>
  )
}

export const SolutionsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation('@mc/next')
  const { pathname, query } = useRouter()

  const handleToggle = () => {
    setIsOpen(!isOpen)
    if (!isOpen) {
      trackSolutionsClick({
        action: 'Solutions',
        pathname,
        query,
      })
    }
  }

  return (
    <Dropdown>
      <DropdownToggle>
        <Button kind='link' className='mc-py-0' onClick={handleToggle}>
          {t('nav.cta.solutions')}
          <IconChevronDownDefault className='mc-ml-2' />
        </Button>
      </DropdownToggle>
      <DropdownContentControlled show={isOpen}>
        <DropdownItem onClick={handleToggle}>
          <Item
            imgSrc='solutions-nav-collective.png'
            title={t('nav.cta.collective')}
            desc={t('nav.cta.collectiveDescription')}
            path={paths.enterpriseCollective}
          />
        </DropdownItem>
        <DropdownItem onClick={handleToggle}>
          <Item
            imgSrc='solutions-nav-accelerator.png'
            title={t('nav.cta.accelerator')}
            desc={t('nav.cta.acceleratorDescription')}
            path={paths.enterpriseAccelerator}
          />
        </DropdownItem>
      </DropdownContentControlled>
    </Dropdown>
  )
}
